import { HandySvg } from "handy-svg";
import styles from "./tryAITool.module.scss";
import { useStore } from "../../stores/use_global_state";
import { useRouter } from "next/router";
import AuthModal from "../AuthModal/AuthModal";
import { useState } from "react";
import { servicesNameList } from "./constants";

const svgProps = { width: 24, height: 24, fill: "transparent" };

const UploadYourFile = ({ dictionary, uploadFile = () => {} }) => {
	const { pathname, push } = useRouter();
	const { state, dispatch } = useStore();
	const { load, isAuth } = state;
	const [showAuthModal, setShowAuthModal] = useState(false);
	const inputAccept = pathname.includes("remove-video-bg") ? ".mp4,.mov, .mkv, video/mp4, .webm, .jpg, .jpeg, .png, image/png, image/jpeg" : ".jpg, .jpeg, .heic, .heif, .png, image/png, image/jpeg";

	const handlerClick = (file) => {
		if (pathname.includes("remove-video-bg")) return uploadFile(file);

		if (!state.isAuth) return setShowAuthModal(true);
		dispatch({ type: "setTemporaryFile", file: file });
		window.scrollTo(0, 0);
		push(`/${pathname}?file=true`);
	};

	return (
		<>
			<section className={styles.section}>
				<h3 className={styles.title}>{dictionary["try_ai_tool_now"] || "Try AI tool now - upload your file"}</h3>
				<ul className={styles.list}>
					<li className={styles.listItem}>
						<HandySvg src={"/try_ai_tool/grid.svg"} {...svgProps} />
						{dictionary["many_services_one_site"] || "Many services - one site"}
					</li>
					<li className={styles.listItem}>
						<HandySvg src={"/try_ai_tool/stars.svg"} {...svgProps} />
						{dictionary["a_place_where_magic_happens"] || "A place where magic happen"}
					</li>
					<li className={styles.listItem}>
						<HandySvg src={"/try_ai_tool/elements.svg"} {...svgProps} />
						{dictionary["unique_content_free_for_commercial_use"] || "Unique content free for commercial use"}
					</li>
				</ul>

				{load && isAuth ? (
					<label className={styles.button} htmlFor="TryAITool" onClick={!isAuth && load ? handlerClick : () => {}}>
						<input className={styles.input} onChange={(event) => handlerClick(event.target.files)} disabled={!isAuth} type="file" name="" id="TryAITool" accept={inputAccept} />
						<HandySvg src={"/illustration_service/editor/upload.svg"} width={24} height={24} fill={"transparent"} />
						{dictionary["Upload file"] || "Upload file"}
					</label>
				) : (
					<button className={styles.button} onClick={() => setShowAuthModal(true)}>
						{dictionary["Try for free"] || "Try for free"}
					</button>
				)}
			</section>

			{showAuthModal && <AuthModal closeHandler={() => setShowAuthModal(false)} serviceName={servicesNameList[pathname.replace("/", "")].name} />}
		</>
	);
};

export default UploadYourFile;
